export default __webpack_public_path__ + "static/media/investment-research.227f25f4.svg";